/**
 * 集合页移动端商品图片滑动组件
 * - 仅在移动端 (<= 768px) 启用
 * - 支持触摸滑动切换商品图
 * - 左下角显示可点击的指示点
 */
;(function () {
  var MOBILE_QUERY = '(max-width: 768px)'

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches
  }

  function initNewSlidersIn(root) {
    if (!root) return
    var containers = root.querySelectorAll
      ? root.querySelectorAll('[data-product-mobile-slider]')
      : []
    Array.prototype.forEach.call(containers, initMobileSlider)
  }

  function initMobileSlider(container) {
    if (!container || container.__initialized) return

    var track = container.querySelector('.mobile-slider__track')
    var slides = Array.prototype.slice.call(
      container.querySelectorAll('.mobile-slider__slide')
    )
    var indicator = container.querySelector('[data-mobile-slider-indicator]')
    if (!track || slides.length === 0 || !indicator) {
      return // 不满足条件直接返回
    }

    var current = 0
    var startX = 0
    var startY = 0
    var deltaX = 0
    var isDragging = false
    var moved = false
    var THRESHOLD = 8 // 触发滑动的像素阈值（更敏感，尽早拦截横向）

    // 构建指示点
    indicator.innerHTML = slides
      .map(function (_, i) {
        return (
          '<span class="mobile-slider__dot' +
          (i === 0 ? ' is-active' : '') +
          '" data-index="' +
          i +
          '"></span>'
        )
      })
      .join('')

    function updateIndicator() {
      var dots = indicator.querySelectorAll('.mobile-slider__dot')
      Array.prototype.forEach.call(dots, function (dot, i) {
        if (i === current) {
          dot.classList.add('is-active')
        } else {
          dot.classList.remove('is-active')
        }
      })
    }

    function goTo(index) {
      if (index < 0) index = 0
      if (index > slides.length - 1) index = slides.length - 1
      current = index
      track.style.transform = 'translateX(-' + current * 100 + '%)'
      updateIndicator()
    }

    // 指示点不再可点击（仅作为视觉提示），因此移除点击事件

    // 触摸滑动
    container.addEventListener(
      'touchstart',
      function (e) {
        if (!isMobile()) return
        if (!e.touches || e.touches.length !== 1) return
        isDragging = true
        moved = false
        startX = e.touches[0].clientX
        startY = e.touches[0].clientY
        deltaX = 0
      },
      { passive: true }
    )

    container.addEventListener(
      'touchmove',
      function (e) {
        if (!isDragging) return
        var x = e.touches[0].clientX
        var y = e.touches[0].clientY
        deltaX = x - startX
        var deltaY = y - startY
        var absX = Math.abs(deltaX)
        var absY = Math.abs(deltaY)

        // 仅在明确横向手势时做滑块或父容器的分配
        var isHorizontal = absX > THRESHOLD && absX >= absY
        if (!isHorizontal) return // 纵向或未超过阈值，交给浏览器默认处理（父容器纵向滚动）

        var atStartBlock = current === 0 && deltaX > 0
        var atEndBlock = current === slides.length - 1 && deltaX < 0
        var blocked = atStartBlock || atEndBlock

        if (blocked) {
          // 被阻挡方向：不要阻止默认，让外层容器在同一次手势中横滑
          track.style.transform = 'translateX(' + -current * 100 + '%)'
          moved = false
          return
        }

        // 非阻挡方向：滑块接管横向手势，阻止父容器横滑，并阻止事件冒泡
        if (e.cancelable) e.preventDefault()
        e.stopPropagation()
        moved = true
        var offset = Math.max(
          -100,
          Math.min(100, (deltaX / (container.clientWidth || 1)) * 100)
        )
        track.style.transform = 'translateX(' + (-current * 100 + offset) + '%)'
      },
      { passive: false }
    )

    container.addEventListener(
      'touchend',
      function () {
        if (!isDragging) return
        isDragging = false
        // 切换阈值：滑动距离需超过容器宽度的 50% 才切换
        var width = container.clientWidth || 1
        var switchThreshold = width * 0.5
        if (Math.abs(deltaX) >= switchThreshold) {
          if (deltaX < 0) {
            // 向左切换，只有在非最后一张时有效
            if (current < slides.length - 1) {
              goTo(current + 1)
            } else {
              goTo(current)
            }
          } else {
            // 向右切换，只有在非第一张时有效
            if (current > 0) {
              goTo(current - 1)
            } else {
              goTo(current)
            }
          }
        } else {
          // 未达到阈值，回弹到当前
          goTo(current)
        }
        deltaX = 0
      },
      { passive: true }
    )

    // 如果发生滑动，则阻止点击跳转商品详情
    container.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault()
          e.stopPropagation()
          moved = false
        }
      },
      true
    )

    // 初始化位置
    goTo(0)
    container.__initialized = true
  }

  function boot() {
    if (!isMobile()) return
    initNewSlidersIn(document)
  }

  document.addEventListener('DOMContentLoaded', boot)
  // 异步脚本可能在 DOMContentLoaded 之后才加载，立即尝试初始化
  if (
    document.readyState === 'interactive' ||
    document.readyState === 'complete'
  ) {
    boot()
  }
  window.addEventListener('resize', function () {
    // 视口变化时，首次进入移动端再初始化即可
    if (isMobile()) boot()
  })
  // 处理移动端浏览器从缓存恢复（BFCache）场景
  window.addEventListener('pageshow', function () {
    if (isMobile()) boot()
  })

  // 处理集合页色板点击，切换第一帧堆叠图片的顶层
  function handleSwatchClick(e) {
    if (!isMobile()) return

    // 兼容点击外层 .swatch__button 的情况
    var label = e.target.closest('.swatch__label')
    if (!label) {
      var button = e.target.closest('[data-swatch-button]')
      if (button) {
        label = button.querySelector('.swatch__label')
      }
    }
    if (!label) return

    var color = (label.getAttribute('data-swatch') || '').toLowerCase()
    var variantId = label.getAttribute('data-swatch-variant')

    var card = label.closest('[data-product-block]')
    if (!card) return

    var stack = card.querySelector('[data-mobile-slider-stack]')
    if (!stack) return

    var imgs = stack.querySelectorAll('[data-stack-img]')
    var currentActive = stack.querySelector('[data-stack-img].is-active')
    var target = null
    Array.prototype.forEach.call(imgs, function (img) {
      var imgVariantId = img.getAttribute('data-variant-id')
      var imgColor = (img.getAttribute('data-color-value') || '').toLowerCase()
      if (!target) {
        if (variantId && imgVariantId === variantId) {
          target = img
        } else if (color && imgColor === color) {
          target = img
        }
      }
    })
    if (target) {
      // 若目标已是激活，直接返回避免闪烁
      if (currentActive === target) {
        // 仍然确保第一帧与点状态同步
        var slider = card.querySelector('[data-product-mobile-slider]')
        if (slider) {
          var track = slider.querySelector('.mobile-slider__track')
          if (track) {
            track.style.transform = 'translateX(0%)'
          }
        }
        return
      }

      // 交叉淡入：先激活目标，让其在顶层动画出现；
      // 延迟移除其它激活项，避免出现空白瞬间
      // 提升目标层级，避免向后切换时旧图覆盖新图
      Array.prototype.forEach.call(imgs, function (img) {
        if (img !== target) img.classList.remove('is-top')
      })
      target.classList.add('is-active')
      target.classList.add('is-top')
      var DURATION = 260 // 与 CSS 动画 0.25s 对齐
      if (stack.__fadeTimeout) {
        clearTimeout(stack.__fadeTimeout)
      }
      stack.__fadeTimeout = setTimeout(function () {
        Array.prototype.forEach.call(imgs, function (img) {
          if (img !== target) img.classList.remove('is-active')
        })
        // 动画结束后，移除临时层级类
        target.classList.remove('is-top')
      }, DURATION)
    }

    // 切回第一帧，并更新指示点状态
    var slider = card.querySelector('[data-product-mobile-slider]')
    if (slider) {
      var track = slider.querySelector('.mobile-slider__track')
      if (track) {
        track.style.transform = 'translateX(0%)'
      }
      var indicator = slider.querySelector('[data-mobile-slider-indicator]')
      if (indicator) {
        var dots = indicator.querySelectorAll('.mobile-slider__dot')
        Array.prototype.forEach.call(dots, function (dot, i) {
          if (i === 0) dot.classList.add('is-active')
          else dot.classList.remove('is-active')
        })
      }
    }
  }

  document.addEventListener('click', handleSwatchClick, true)

  // 监听动态内容插入（例如 Ajaxinate 加载下一页、推荐商品异步插入等），自动为新加入的商品卡片初始化滑动
  // 使用 MutationObserver，避免依赖主题内部事件
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      if (!isMobile()) return
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(
          mutation.addedNodes || [],
          function (node) {
            // 仅处理元素节点
            if (node.nodeType !== 1) return
            // 直接是滑动容器或其子树包含滑动容器
            if (node.matches && node.matches('[data-product-mobile-slider]')) {
              initMobileSlider(node)
            } else {
              initNewSlidersIn(node)
            }
          }
        )
      })
    })

    try {
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      })
    } catch (e) {
      // 忽略无法观察的异常
    }
  }
})()
